/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Topsection_Checkoffer2Inputs */

const id_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat Penawaran`)
};

const ms_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat Tawaran`)
};

const da_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se Tilbud`)
};

const de_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angebot ansehen`)
};

const en_us2_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check Offer`)
};

const es_es2_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver oferta`)
};

const es_mx2_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver oferta`)
};

const fil_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingnan ang Offer`)
};

const fr_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir l'offre`)
};

const it_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi offerta`)
};

const hu_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajánlat megtekintése`)
};

const nl_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijk aanbod`)
};

const no_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sjekk tilbud`)
};

const pl_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprawdź ofertę`)
};

const pt_br2_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check Offer`)
};

const pt_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver oferta`)
};

const ro_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vezi oferta`)
};

const fi_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarkista tarjous`)
};

const sv_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolla erbjudande`)
};

const vi_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem ưu đãi`)
};

const tr_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teklifi İncele`)
};

const cs_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazit nabídku`)
};

const bg_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вижте офертата`)
};

const ru_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посмотреть предложение`)
};

const uk_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переглянути`)
};

const ar_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصفح العرض`)
};

const hi_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफ़र देखें`)
};

const th_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูข้อเสนอ`)
};

const ja_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オファーを見る`)
};

const zh_cn2_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check Offer`)
};

const zh_hant1_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check Offer`)
};

const ko_components_topsection_checkoffer2 = /** @type {(inputs: Components_Topsection_Checkoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check Offer`)
};

/**
* | output |
* | --- |
* | "Check Offer" |
*
* @param {Components_Topsection_Checkoffer2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_topsection_checkoffer2 = /** @type {((inputs?: Components_Topsection_Checkoffer2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Topsection_Checkoffer2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_topsection_checkoffer2(inputs)
	if (locale === "ms") return ms_components_topsection_checkoffer2(inputs)
	if (locale === "da") return da_components_topsection_checkoffer2(inputs)
	if (locale === "de") return de_components_topsection_checkoffer2(inputs)
	if (locale === "en-US") return en_us2_components_topsection_checkoffer2(inputs)
	if (locale === "es-ES") return es_es2_components_topsection_checkoffer2(inputs)
	if (locale === "es-MX") return es_mx2_components_topsection_checkoffer2(inputs)
	if (locale === "fil") return fil_components_topsection_checkoffer2(inputs)
	if (locale === "fr") return fr_components_topsection_checkoffer2(inputs)
	if (locale === "it") return it_components_topsection_checkoffer2(inputs)
	if (locale === "hu") return hu_components_topsection_checkoffer2(inputs)
	if (locale === "nl") return nl_components_topsection_checkoffer2(inputs)
	if (locale === "no") return no_components_topsection_checkoffer2(inputs)
	if (locale === "pl") return pl_components_topsection_checkoffer2(inputs)
	if (locale === "pt-BR") return pt_br2_components_topsection_checkoffer2(inputs)
	if (locale === "pt") return pt_components_topsection_checkoffer2(inputs)
	if (locale === "ro") return ro_components_topsection_checkoffer2(inputs)
	if (locale === "fi") return fi_components_topsection_checkoffer2(inputs)
	if (locale === "sv") return sv_components_topsection_checkoffer2(inputs)
	if (locale === "vi") return vi_components_topsection_checkoffer2(inputs)
	if (locale === "tr") return tr_components_topsection_checkoffer2(inputs)
	if (locale === "cs") return cs_components_topsection_checkoffer2(inputs)
	if (locale === "bg") return bg_components_topsection_checkoffer2(inputs)
	if (locale === "ru") return ru_components_topsection_checkoffer2(inputs)
	if (locale === "uk") return uk_components_topsection_checkoffer2(inputs)
	if (locale === "ar") return ar_components_topsection_checkoffer2(inputs)
	if (locale === "hi") return hi_components_topsection_checkoffer2(inputs)
	if (locale === "th") return th_components_topsection_checkoffer2(inputs)
	if (locale === "ja") return ja_components_topsection_checkoffer2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_topsection_checkoffer2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_topsection_checkoffer2(inputs)
	return ko_components_topsection_checkoffer2(inputs)
});
export { components_topsection_checkoffer2 as "components.topSection.checkOffer" }